import { client } from './client';
import interceptors from './interceptors';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getLocation() {
	return client.get('/tunnel/get-location');
}

export default {
	getLocation
};